import { render, staticRenderFns } from "./Seal.vue?vue&type=template&id=9fb18a62&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Seal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/Seal.vue
// module id = 2247
// module chunks = 1